<template>
  <div
    class="flex flex-col border-r border-default bg-default"
    :class="{ 'w-16': !open, 'w-[300px]': open }"
  >
    <header class="h-16 flex items-center border-b border-default p-3.5">
      <UButton
        :icon="open ? 'lucide:panel-left-close' : 'lucide:panel-left-open'"
        @click="open = !open"
        variant="ghost"
        color="neutral"
      />
    </header>

    <div class="flex flex-col p-[10px] gap-3 sticky top-0">
      <UButton
        to="/"
        icon="lucide:house"
        variant="ghost"
        color="neutral"
        active-color="primary"
        label="Dashboard"
      />
      <UButton
        to="/campaigns"
        icon="lucide:book"
        variant="ghost"
        color="neutral"
        active-color="primary"
        label="Campaigns"
      />
      <UButton
        v-if="user?.isAdmin"
        to="/users"
        icon="lucide:user"
        variant="ghost"
        color="neutral"
        active-color="primary"
        label="Users"
      />
      <template v-if="sections.length">
        <USeparator />
        <UTooltip
          v-for="section in sections"
          :key="section.id"
          :text="section.label"
          :disabled="open"
          :content="{ side: 'right' }"
        >
          <UButton
            :icon="section.icon"
            :label="section.label"
            variant="ghost"
            color="neutral"
            class="w-full"
            @click="scrollToSection(section.id)"
          />
        </UTooltip>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { user } = useUserSession();
const { sections } = storeToRefs(useSidebarStore());

const open = ref(false);

const scrollToSection = (id: string) =>
  document
    .getElementById(id)
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
</script>

<style></style>
